module.exports = __webpack_public_path__ + "img/caroussel1.dcbbbd2f.jpeg";